<template>
  <v-row>

    <v-col cols="12">

      <base-card>

        <v-card-title>
          {{ editing ? 'Editar Configuración Puntos Colombia' : 'Configuración Puntos Colombia' }}
        </v-card-title>

        <v-card-text>

          <v-form
            ref="form"
          >

            <!-- Compañía -->
            <v-row>

              <v-col
                v-if="hasElevatedRole"
                cols="12"
                md="4"
              >
                <v-select
                  ref="cliente"
                  v-model="form.IdCompania"
                  :items="filteredClients"
                  item-text="text"
                  item-value="IdCompania"
                  label="Compañía"
                  prepend-inner-icon="mdi-sitemap"
                  :disabled="editing"
                  :rules="[requiredRule]"
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          v-model="search"
                          hide-details
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                        />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

            </v-row>

            <!-- Configuración -->
            <v-row>

              <v-col
                cols="12"
                md="2"
              >
                <v-select
                  v-model="form.Environment"
                  :items="['UAT', 'PRD']"
                  label="Ambiente"
                  :rules="[requiredRule]"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="form.PartnerCode"
                  label="Partner Code"
                  :rules="[requiredRule]"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-select
                  v-model="form.Channel"
                  :items="channelItems"
                  item-text="text"
                  item-value="value"
                  label="Canal"
                  :rules="[requiredRule]"
                />
              </v-col>

            </v-row>

            <!-- Credenciales -->
            <v-row>

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.ClientId"
                  label="Client Id"
                  :rules="[requiredRule]"
                />
              </v-col>

              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.ClientSecret"
                  label="Client Secret"
                  :rules="[requiredRule]"
                  :append-icon="showClientSecret ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showClientSecret ? 'text' : 'password'"
                  @click:append="showClientSecret = !showClientSecret"
                >
                  <template v-slot:append-outer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="copyText(form.ClientSecret)"
                        >
                          <v-icon small>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </template>

                      <span>Copiar Client Secret</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>

            </v-row>

            <!-- Certificado -->
            <v-row>

              <v-col
                cols="12"
                md="6"
              >
                <v-file-input
                  v-model="certificate"
                  accept=".p12"
                  label="Certificado P12"
                  prepend-icon="mdi-file-certificate"
                  :rules="editing ? [] : [requiredRule]"

                />
              </v-col>

              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.CertificatePassword"
                  label="Password Certificado"
                  :rules="[requiredRule]"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                >
                  <template v-slot:append-outer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="copyText(form.CertificatePassword)"
                        >
                          <v-icon small>
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </template>

                      <span>Copiar contraseña</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>

            </v-row>

            <!-- Botones -->
            <v-row>

              <v-col
                v-if="editing"
                cols="12"
                md="6"
              />
              <v-col
                v-if="!editing"
                cols="12"
                md="8"
              />

              <v-col
                v-if="editing"
                cols="12"
                md="2"
              >
                <v-btn
                  block
                  outlined
                  color="grey"
                  @click="cancelEdit"
                >
                  CANCELAR
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <v-btn
                  block
                  style="background-color: rgb(204 33 40); color: white !important;"
                  dark
                  @click="save"
                >
                  {{ editing ? 'ACTUALIZAR' : 'GUARDAR' }}
                </v-btn>
              </v-col>



            </v-row>


              <v-alert
                v-show="successAlert"
                type="success"
                text
                class="mb-4"
              >
                {{ msgSuccessAlert }}
              </v-alert>


          </v-form>

        </v-card-text>

      </base-card>

    </v-col>

  </v-row>
</template>

<script>
export default {

  data() {

    return {
      editing: false,
      successAlert: false,
      msgSuccessAlert: '',
      search: '',
      isAdmin: false,
      isAdminID: false,
      isDev: false,
      certificate: null,
      showPassword: false,
      showClientSecret: false,

      requiredRule: value => {
        if (
          value === null ||
          value === undefined ||
          (typeof value === 'string' && !value.trim())
        ) {
          return 'Este campo es obligatorio'
        }

        return true
      },

      channelItems: [
        {
          text: 'POS (ERP)',
          value: 'L'
        }
      ],

      form: {
        IdCompania: '',
        Environment: 'UAT',
        ClientId: '',
        ClientSecret: '',
        PartnerCode: '',
        Channel: 'L',
        CertificatePassword: ''
      },

      originalForm: null

    }

  },

  async created() {

    const user = JSON.parse(
      atob(localStorage.getItem('uid'))
    )

    this.isAdmin =
      user.rol === 'Administrador'

    this.isAdminID =
      user.rol === 'AdminI+D'

    this.isDev =
      user.rol === 'Desarrollador'

    await this.$store.dispatch(
      'invoice/getListClients'
    )

    await this.$store.dispatch(
      'loyaltyPuntosColombia/getConfigs'
    )

  },

  computed: {

    filteredClients() {

      if (!this.search) {
        return this.availableClients
      }

      return this.availableClients.filter(
        item =>
          item.text
            .toLowerCase()
            .includes(
              this.search.toLowerCase()
            )
      )

    },

    detailClients() {

      const companies =
        (
          this.$store.state
            .invoice
            .listClients
            .Mensaje
          || []
        )
          .filter(
            compania =>
              compania.Activo === 1
          )
          .map(compania => ({
            ...compania,
            text:
              '[' +
              compania.IdCompania +
              '] ' +
              compania.NombreCompania
          }))

      return companies

    },

    availableClients() {

      const configured =
        (
          this.$store.state
            .loyaltyPuntosColombia
            .configs
          || []
        )
          .map(
            x => x.IdCompania
          )

      return this.detailClients.filter(client => {

        // Permitir la compañía que se está editando
        if (
          client.IdCompania ===
          this.form.IdCompania
        ) {
          return true
        }

        return !configured.includes(
          client.IdCompania
        )

      })

    },

    hasElevatedRole() {

      return (
        this.isAdmin ||
        this.isAdminID ||
        this.isDev
      )

    }

  },

  methods: {

    async save() {

      // Validar formulario
      const isValid =
        this.$refs.form.validate()

      if (!isValid) {
        return
      }

      this.successAlert = false
      this.msgSuccessAlert = ''

      const formData =
        new FormData()

      Object.keys(this.form)
        .forEach(key => {

          formData.append(
            key,
            this.form[key]
          )

        })

      if (this.certificate) {

        formData.append(
          'certificate',
          this.certificate
        )

      }

      const response =
        await this.$store.dispatch(
          'loyaltyPuntosColombia/saveConfig',
          formData
        )

      await this.$store.dispatch(
        'loyaltyPuntosColombia/getConfigs'
      )

      if (
        response &&
        response.data &&
        response.data.message
      ) {

        this.successAlert = true

        this.msgSuccessAlert =
          response.data.message

        setTimeout(() => {

          this.resetForm()

          this.successAlert = false
          this.msgSuccessAlert = ''

        }, 2000)

      } else {

        this.resetForm()

      }

    },

    load(config) {

      this.editing = true

      this.form = {
        IdCompania: config.IdCompania,
        Environment: config.Environment,
        ClientId: config.ClientId,
        ClientSecret: config.ClientSecret,
        PartnerCode: config.PartnerCode,
        Channel: config.Channel,
        CertificatePassword:
        config.CertificatePassword
      }

      // Guardar copia de los datos originales
      this.originalForm = {
        ...this.form
      }

      this.certificate = null

    },

    resetForm() {

      this.editing = false
      this.certificate = null

      this.form = {
        IdCompania: '',
        Environment: 'UAT',
        ClientId: '',
        ClientSecret: '',
        PartnerCode: '',
        Channel: '',
        CertificatePassword: ''
      }

      this.originalForm = null

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

    },

    cancelEdit() {

      this.resetForm()

    }

  }

}
</script>
